import { MarketplaceNavbarButton } from "../../Marketplace/MarketplaceNavbar/MarketplaceNavbar.styled";
import { UserNavbarMain, UserNavbarWrapper, UserProfileButton } from "./UserNavbar.styled";
import { toggleCreateCollectionModal } from "../../../store/app/appSlice";
import { useDispatch } from "react-redux";

export const UserNavbar = ({ tabList, activeTab, setActiveTab, MyProfile }) => {
  const dispatch = useDispatch();
  return (
    <UserNavbarWrapper>
      <div className='container'>
        <UserNavbarMain>
          <div>
            {tabList.map((tab, i) => (
              <MarketplaceNavbarButton key={i} className={activeTab === tab && "active"} onClick={() => setActiveTab(tab)}>
                {tab}
              </MarketplaceNavbarButton>
            ))}
          </div>
          {MyProfile && activeTab === "Collections" ? (
            <UserProfileButton to onClick={() => dispatch(toggleCreateCollectionModal())}>
              Create Collection
            </UserProfileButton>
          ) : activeTab === "Collected" ? (
            <UserProfileButton to='/'>Browse Marketplace</UserProfileButton>
          ) : (
            <UserProfileButton to='/create-nft'>Create NFT</UserProfileButton>
          )}
        </UserNavbarMain>
      </div>
    </UserNavbarWrapper>
  );
};
